import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import { PurchaseMethods } from '@sm360/widget-commons-vehicle';
import { InputDropDown } from '@sm360/widget-commons-forms';

import 'payment-calculator/components/Distance/Distance.scss';

const Distance = ({ purchaseMethods, onKMPlanClick }) => {
    const kmPlanParameters = purchaseMethods.getSelectedFinanceKMPlanParameters(LocaleService);
    if (kmPlanParameters.annualKMAllowed <= 0 || !kmPlanParameters.kmPlanOptions) {
        return null;
    }
    const onChange = (kmPlanOption) => onKMPlanClick(kmPlanOption);

    return (
        <div className="section-distance">
            <div className="distance_title is-light">{LocaleService.t('PAYMENT_CALCULATOR.KMPLANS.TITLE')}</div>
            <InputDropDown
                name="KMPlans"
                options={kmPlanParameters.kmPlanOptions.sort((a, b) => a.value - b.value)}
                value={kmPlanParameters.selectedKMPlan.value}
                valueChange={onChange}
                classNames={['input-dropdown sr-paymentCalculator-dropdown']}
            />
        </div>
    );
};

Distance.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    onKMPlanClick: PropTypes.func.isRequired,
};

Distance.displayName = 'Distance';

export default Distance;



// WEBPACK FOOTER //
// ./src/components/Distance/Distance.jsx